import { useMemo } from "react";
import { parseMoodTimestamp } from "utils/common/timestampUtils";
import type { Mood } from "../../../types/models";

export interface MonthInfo {
  key: string;
  label: string;
}

export function useMonthManagement(moods: Mood[], selectedMonthKey: string) {
  const availableMonths = useMemo(() => {
    if (!moods?.length) return [];
    const map = new Map<string, { year: number; month0: number }>();
    moods.forEach((mood) => {
      const d = parseMoodTimestamp(mood);
      if (!d) return;
      const y = d.getUTCFullYear();
      const month0 = d.getUTCMonth();
      const key = `${y}-${String(month0 + 1).padStart(2, "0")}`;
      if (!map.has(key)) map.set(key, { year: y, month0 });
    });
    return Array.from(map.entries())
      .map(([key, { year, month0 }]) => ({
        key,
        label: new Date(Date.UTC(year, month0, 1)).toLocaleDateString(
          undefined,
          { month: "short", year: "numeric", timeZone: "UTC" }
        ),
      }))
      .sort((a, b) => b.key.localeCompare(a.key));
  }, [moods]);

  const effectiveSelectedMonth =
    selectedMonthKey && availableMonths.some((m) => m.key === selectedMonthKey)
      ? selectedMonthKey
      : availableMonths[0]?.key || "";

  return { availableMonths, effectiveSelectedMonth };
}
